<template>
  <div class="p-0">
    <h6 class="text-two">
      {{ question.semiology_form_question_type_description }}
    </h6>
    <div
      class="form-check"
      v-for="(item, key) in question.alternatives"
      :key="`${item.id}-${key}`"
    >
      <input
        :disabled="form.status == 'FINALIZADO' || !linked_profile_id_can_answer"
        :checked="item.answer ? true : false"
        class="form-check-input multiple-choice"
        type="checkbox"
        :id="`multiple-choice-${item.id}`"
        :data-id="item.id"
        :data-question_id="question.id"
        @input="emit"
      />
      <label :for="`multiple-choice-${item.id}`" class="form-check-label">
        {{ item.label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",

  props: {
    linked_profile_id_can_answer: {
      type: Boolean,
      default: true,
    },

    form: Object,
    category_id: [String, Number],
    question: Object,
  },

  methods: {
    emit(e) {
      let answer = [];

      let multiple_choice = document.querySelectorAll(".multiple-choice");

      for (let input of multiple_choice) {
        if (input.dataset.question_id == e.target.dataset.question_id) {
          if (input.dataset.id == e.target.dataset.id) {
            input.checked = e.target.checked;
            answer.push({ id: input.dataset.id, checked: e.target.checked });
          } else {
            answer.push({
              id: input.dataset.id,
              checked: input.checked == undefined ? false : input.checked,
            });
          }
        }
      }

      this.answer = answer;

      this.$emit("answer", {
        category_id: this.category_id,
        id: this.question.id,
        answer,
      });
    },
  },
};
</script>
